import React, { useState } from "react";
import { FaRegCircle } from "react-icons/fa";
import { FaRegCircleCheck } from "react-icons/fa6";
import { MdCheck, MdOutlineCopyAll } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import ErrorMessage from "../../Components/ErrorMessage";
import { Spinner } from "react-bootstrap";
import OpenOrgDeleteModal from "./OpenOrgDeleteModal";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenOrgDelete = ({ account_id, userData, org_id }) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [loadingDeleteMcp, setLoadingDeleteMcp] = useState(false)
    const [inputValue, setInputValue] = useState("")
    const [checkCopy, setCheckCopy] = useState(false)
    const [checkedItems, setCheckedItems] = useState([false, false, false, false, false]);
    const [statusDelete, setStatusDelete] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [loadinDeleteOrg, setLoadingDeleteOrg] = useState(false)

    const toggleCheck = (index) => {
        const newChecked = [...checkedItems];
        newChecked[index] = !newChecked[index];
        setCheckedItems(newChecked);
    };

    const copyItem = (item) => {
        navigator.clipboard.writeText(item)
            .then(() => {
                setCheckCopy(true);
                setTimeout(() => {
                    setCheckCopy(false);
                }, 2000);
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const handleCheckOpenDelete = () => {
        setErrorMessage({ message: "", display: false })

        if (!checkedItems.every(Boolean)) {
            setErrorMessage({ message: t.organizations.all_warnings_mex, display: true });
            return;
        }

        if (inputValue != org_id) {
            setErrorMessage({ message: `${t.type_confirm} ${org_id}`, display: true });
            return;
        }

        setOpenConfirm(true)
    }

    const handleDeleteOrg = async () => {
        setLoadingDeleteOrg(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/delete_organization`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.status == "OK") {
                navigate("/e8console/organizations")
            }

        } catch (error) {
            setLoadingDeleteOrg(false)
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingDeleteOrg(false);
        }
    }

    return (
        <div className="open_item_form">
            <div className="delete_item_parag">
                {t.organizations.warning_points.map((text, index) => (
                    <div
                        key={index}
                        className="delete_warning_inner_item"
                        onClick={() => toggleCheck(index)}
                    >
                        <i className={checkedItems[index] ? "delete_warning_inner_item_i_selected" : "delete_warning_inner_item_i"}>
                            {checkedItems[index] ? <FaRegCircleCheck /> : <FaRegCircle />}
                        </i>
                        <p style={{ margin: 0 }}>{text}</p>
                    </div>
                ))}
                <p className="delete_warning_inner_p" dangerouslySetInnerHTML={{__html: t.organizations.warning_del}}>
                </p>
            </div>
            <div className="modal_profile_input_cont">
                <div className="label_input">
                    <label className="input_label">
                        {t.type_confirm} "<strong>{org_id}</strong>"
                        <button className="path_item_root_btn" title="Copy" onClick={() => copyItem(org_id)}>{checkCopy ? <i className="fade-in"> <MdCheck /></i> : <i className="fade-in"><MdOutlineCopyAll /></i>}</button>

                    </label>
                    <input
                        type="text"
                        name="name"
                        maxLength={100}
                        placeholder={`${t.type_confirm}: "${org_id}"`}
                        className="register_form_first fade-in"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        autoComplete="off"
                    />
                </div>
            </div>
            <button className="open_item_form_btn open_item_form_btn_delete fade-in" onClick={handleCheckOpenDelete}>
                {loadingDeleteMcp ? (
                    <Spinner loading={true} />
                ) : (
                    t.delete
                )}
            </button>
            <ErrorMessage err={errorMessage} />

            <OpenOrgDeleteModal
                show={openConfirm}
                handleClose={() => setOpenConfirm(false)}
                errorMessage={errorMessage}
                handleDeleteOrg={handleDeleteOrg}
                loadinDeleteOrg={loadinDeleteOrg}
            />
        </div>
    )
}

export default OpenOrgDelete